import api from './api';

export const getListingConfiguration = async (moduleKey) => {
  const response = await api.get(`/listing-preferences/${encodeURIComponent(moduleKey)}`);
  return response.data;
};

export const saveListingPreferences = async (moduleKey, preferences) => {
  const response = await api.put(`/listing-preferences/${encodeURIComponent(moduleKey)}`, { preferences });
  return response.data;
};

export const saveListingView = async (moduleKey, name, config) => {
  const response = await api.post(`/listing-preferences/${encodeURIComponent(moduleKey)}/views`, { name, config });
  return response.data?.view;
};

export const updateListingView = async (moduleKey, viewId, name, config) => {
  const response = await api.put(
    `/listing-preferences/${encodeURIComponent(moduleKey)}/views/${encodeURIComponent(viewId)}`,
    { name, config }
  );
  return response.data;
};

export const deleteListingView = async (moduleKey, viewId) => {
  const response = await api.delete(
    `/listing-preferences/${encodeURIComponent(moduleKey)}/views/${encodeURIComponent(viewId)}`
  );
  return response.data;
};
